import "./App.css";
import React, { useEffect, useState, useCallback, useRef } from "react";

function App() {
  const [quickInfo, setQuickInfo] = useState({});
  const [hapurl, setHapurl] = useState("");
  const [cpaurl, setCpaurl] = useState("");
  const [downurl, setDownurl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [haplist, setHaplist] = useState([]);
  const [hapIndex, setHapIndex] = useState(0);
  const [cpaDetailData, setCpaDetailData] = useState({});

  // 用于标记是否已经跳转成功，避免重复执行
  const hasJumped = useRef(false);
  // 标记是否已经执行过fetch请求，避免重复请求
  const hasFetched = useRef(false);
  // 保存定时器和iframe引用，方便清理
  const timerRef = useRef(null);
  const iframeRef = useRef(null);

  const getUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(
      urlParams.get("tid"),
      urlParams.get("lbid"),
      urlParams.get("pageId"),
    );
    const params = {
      credentialId: urlParams.get("quickKey") || "",
      packageName: urlParams.get("quickAppName"),
      imeiMd5: urlParams.get("imei") || "",
      imei: urlParams.get("imei") || "",
      ip: urlParams.get("ip") || "",
      hm: urlParams.get("hm") || urlParams.get("channel"),
      oaidMd5: urlParams.get("oaid") || "",
      oaid: urlParams.get("oaidplain") || "",
      requestid: urlParams.get("requestid"),
      model: urlParams.get("model"),
      androidid: urlParams.get("androidid") || "",
      androididMd5: urlParams.get("androidid") || "",
      userAgent: urlParams.get("ua"),
      networkType: urlParams.get("nettype"),
      startupTime: Date.now(),
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      tid: urlParams.get("tid") ? encodeURIComponent(urlParams.get("tid")) : "",
      lbid: urlParams.get("lbid"),
      pageId: urlParams.get("pageId"),
      adid: urlParams.get("adid") || "",
      sourceType: urlParams.get("sourceType") || "2",
      cpaType: 1,
      channel: urlParams.get("channel"),
    };
    if (params.channel == "AIQIYI") {
      params.impressId = urlParams.get("impress_id");
    }
    return params;
  };

  // 重置所有状态和标记，用于重新进入页面
  const resetState = useCallback(() => {
    setCpaDetailData({});
    setHapurl("");
    setCpaurl("");
    setDownurl("");
    setLoading(true);
    setError(null);
    hasJumped.current = false;
    hasFetched.current = false;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (iframeRef.current && document.body.contains(iframeRef.current)) {
      document.body.removeChild(iframeRef.current);
      iframeRef.current = null;
    }
  }, []);

  // 页面可见性变化的监听函数
  const handleVisibilityChange = useCallback(() => {
    console.log("页面可见性变化", document.hidden);

    if (document.hidden) {
      // 页面被隐藏，说明iframe跳转成功
      hasJumped.current = true;
      // 清理iframe和定时器
      if (iframeRef.current) {
        document.body.removeChild(iframeRef.current);
        iframeRef.current = null;
      }
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    } else {
      // 页面重新显示 重新发起请求
      resetState();
      setTimeout(() => {
        const params = getUrlParams();
        fetchData(params);
      }, 1000);
    }
  }, []);

  // 页面失去焦点的兜底监听
  const handleWindowBlur = useCallback(() => {
    console.log("页面失去焦点");

    if (!document.hidden) {
      hasJumped.current = true;
    }
  }, []);

  // 上报点击的独立函数（抽离出来，方便多处调用）
  const reportClick = (cpaDetail) => {
    if (!cpaDetail.cpaId) return; // 无cpaId时不上报
    console.log(cpaDetail, "页面不可见上报点击"); // 现在会正常打印
    const params = getUrlParams();
    fetch("https://toufang.mwadmore.cn/api/ad/click", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...params,
        cpaType: 1,
        cpaId: cpaDetail.cpaId,
      }),
    })
      .then((response) => {
        console.log("上报成功", response);
      })
      .catch((err) => {
        console.error("上报失败", err);
      });
  };

  // 抽离openDeepLinkWithIframe，补充依赖
  const openDeepLinkWithIframe = useCallback((url1, url2, url3, cpaDetail) => {
    console.log("openDeepLinkWithIframe", { url1, url2, url3 });

    if (hasJumped.current) return;

    // 如果有CPA链接，先尝试CPA链接
    if (url1) {
      console.log("尝试CPA链接跳转");

      // 重置标记
      hasJumped.current = false;

      // 创建隐藏的iframe
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.width = "0px";
      iframe.style.height = "0px";
      iframe.src = url1;
      iframeRef.current = iframe;
      document.body.appendChild(iframe);
      setTimeout(() => {
        if (document.hidden) {
          reportClick(cpaDetail);
        }
      }, 1000);
      // 2秒后检查是否跳转成功
      timerRef.current = setTimeout(() => {
        // 如果页面仍可见，说明iframe跳转失败，尝试下载链接
        console.log(1111111111);

        if (!document.hidden && !hasJumped.current) {
          console.log("CPA链接跳转失败，尝试下载链接");

          if (iframeRef.current) {
            document.body.removeChild(iframeRef.current);
            iframeRef.current = null;
          }

          // 如果有下载链接，跳转下载链接
          if (url2) {
            window.location.href = url2;
          }
          // 如果下载链接也没有，尝试HAP链接
          else if (url3) {
            console.log("下载链接为空，尝试HAP链接");
            window.location.href = hapUrlreset(url3);
          }
        }
        // hasJumped.current = false; // 重置标记，方便下次调用
      }, 2000);
    } else {
      // 如果有下载链接，跳转下载链接
      if (url2) {
        window.location.href = url2;
      }
      // 如果下载链接也没有，尝试HAP链接
      else if (url3) {
        console.log("下载链接为空，尝试HAP链接");
        window.location.href = hapUrlreset(url3);
      }
    }
  }, []);

  const hapUrlreset = (url) => {
    const params = getUrlParams();
    let impressId = params.channel == "AIQIYI" ? params.impressId : "";
    if (params.hm == "OPPO") {
      // let tid = encodeURIComponent(params.tid);
      // 判断tid是否有空格
      url = `${url}${encodeURIComponent(
        `&channel=${params.channel}&tid=${params.tid || ""}&lbid=${
          params.lbid || ""
        }&pageId=${params.pageId || ""}&sourceType=${
          params.sourceType ? params.sourceType : 2
        }&adid=${params.adid || ""}&impressId=${impressId || ""}`,
      )}`;
      console.log(url, "url");

      return url;
    } else {
      return `${url}&channel=${params.channel}&sourceType=${
        params.sourceType ? params.sourceType : 2
      }&adid=${params.adid}&impressId=${impressId}`;
    }
    // return url;
  };

  // 抽离fetchData，加入useCallback
  const fetchData = useCallback(
    (params) => {
      // 防止重复请求
      if (hasFetched.current) return;
      hasFetched.current = true;

      setLoading(true);
      setError(null);
      // https://toufang.mwadmore.cn
      // http://153.3.230.130:8099
      fetch("https://toufang.mwadmore.cn/api/ad/cpa", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json().then((data) => {
              console.log("API响应数据:", data);
              const haplist = data.hapurl || [];
              console.log(haplist, "haplist");

              const hapurl = haplist[hapIndex] || "";
              const privacy = data.privacy || {};
              let cpaDetail = data.cpaDetail || {};
              const cpaurl = cpaDetail.url || "";
              const downUrl = cpaDetail.downUrl || "";
              // hapIndex + 1,如果hapIndex = haplist.length - 1,则hapIndex = 0
              setHapIndex((hapIndex + 1) % haplist.length);
              console.log("解析结果:", { hapurl, cpaurl, downUrl });
              setCpaDetailData(cpaDetail);
              setHaplist(haplist);
              setQuickInfo(privacy);
              setHapurl(hapurl);
              setCpaurl(cpaurl);
              setDownurl(downUrl);
              setLoading(false);

              // 返回数据用于后续处理
              return { hapurl, cpaurl, downUrl, cpaDetail };
            });
          } else {
            throw new Error(`HTTP错误: ${response.status}`);
          }
        })
        .then((data) => {
          // 数据获取成功后，根据优先级触发跳转逻辑
          console.log(data, "data");
          // return;
          if (data.cpaurl || data.downUrl || data.hapurl) {
            // 使用setTimeout确保DOM更新完成后再执行跳转
            setTimeout(() => {
              openDeepLinkWithIframe(
                data.cpaurl,
                data.downUrl,
                data.hapurl,
                data.cpaDetail,
              );
            }, 600);
          }
        })
        .catch((err) => {
          console.error("请求失败：", err);
          setError(err.message);
          setLoading(false);
          hasFetched.current = false; // 失败时重置，可重试
        });
    },
    [openDeepLinkWithIframe],
  );

  // 第一个useEffect：仅初始化参数+执行一次fetch
  useEffect(() => {
    // 每次组件挂载时重置状态
    resetState();

    const params = getUrlParams();
    fetchData(params);

    // 绑定事件监听
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("blur", handleWindowBlur);

    // 组件卸载时清理
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("blur", handleWindowBlur);
      if (timerRef.current) clearTimeout(timerRef.current);
      if (iframeRef.current && document.body.contains(iframeRef.current)) {
        document.body.removeChild(iframeRef.current);
      }
    };
  }, [fetchData, handleVisibilityChange, handleWindowBlur, resetState]); // 补充所有依赖

  // 打开隐私政策
  const openPrivacyPolicy = useCallback(
    (e) => {
      if (e) e.stopPropagation();
      if (quickInfo.url) {
        window.location.href = quickInfo.url;
      } else {
        handleManualJump();
      }
    },
    [quickInfo.url],
  );

  // 手动触发跳转
  const handleManualJump = () => {
    openDeepLinkWithIframe(cpaurl, downurl, hapurl);
  };

  return (
    <div className="container" onClick={handleManualJump}>
      <div className="container-top">
        <div className="container-top1">轻松每一天</div>
        <div className="container-top2">该页面跳转{quickInfo.appName}</div>
        <div className="container-top3" onClick={handleManualJump}>
          立即打开
        </div>
      </div>
      <div className="center">
        <img
          src={require("./img/bg.webp")}
          className="center-img"
          loading="lazy"
        />
      </div>
      <div className="footer">
        <div className="footer-top">
          <div>应用名称：{quickInfo.appName} | &nbsp;</div>
          <div>应用版本：V{quickInfo.version}</div>
        </div>
        <div className="footer-center">开发者：{quickInfo.company}</div>
        <div className="footer-center">备案号：沪ICP备2021015411号-15</div>
        <div className="footer-center">更新时间：{quickInfo.updateTime}</div>
        <div
          className="footer-bottom"
          onClick={(e) => {
            e.stopPropagation();
            openPrivacyPolicy();
          }}
        >
          {"隐私政策>>"}
        </div>
      </div>
    </div>
  );
}

export default App;
